import { useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import request from '../../services/Request';
import React, { useState, useContext, useEffect } from 'react';
import { UserContext } from '../contexts/userContext';
import Papa from 'papaparse';
import {
  Button,
  Box,
  Typography,
  Paper,
  alpha,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Modal } from '../../components/BootstrapToMUI';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DownloadIcon from '@mui/icons-material/Download';
import ImageIcon from '@mui/icons-material/Image';
import DescriptionIcon from '@mui/icons-material/Description';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DataObjectIcon from '@mui/icons-material/DataObject';

export default function ImportProducts(props) {
  const theme = useTheme();
  const { show, onHide } = props;
  const { userEmail, role, referTo } = useContext(UserContext);

  let id = '';
  let userId = useLocation().pathname.split('/').slice(-1)[0];

  if (userId.includes('@')) {
    id = userId;
  } else {
    if (role === 'Admin') id = userEmail;
    else id = referTo;
  }

  const [prod, setProd] = useState([]);
  const [fileName, setFileName] = useState('');
  const [image, setImage] = useState([]);

  const [jsonFileName, setJsonFileName] = useState('');
  const [jsonProducts, setJsonProducts] = useState([]);
  const [jsonImages, setJsonImages] = useState([]);

  useEffect(() => {
    if (show) {
      setImage([]);
      setProd([]);
      setFileName('');
      setJsonFileName('');
      setJsonProducts([]);
      setJsonImages([]);
    }
  }, [show]);

  const downloadTemplate = () => {
    window.open(`${process.env.REACT_APP_SERVER_API}/download/importProducts/ImportProducts`);
  };

  const downloadTemplateImage = () => {
    window.open(
      `${process.env.REACT_APP_SERVER_API}/download/importProducts/ImportProductImageExCode`
    );
  };

  const downloadTemplateImageUPC = () => {
    window.open(
      `${process.env.REACT_APP_SERVER_API}/download/importProducts/ImportProductImageUPC`
    );
  };

  const submit = () => {
    console.log('prod', prod);
    Swal.fire({
      title: `Please Wait for response`,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    request({
      method: 'post',
      url: `/products/importProducts`,
      data: {
        prod: prod,
        referTo: id,
      },
    })
      .then((res) => {
        Swal.fire({
          icon: 'success',
          text: `Your products have been imported successfully.`,
        }).then(() => {
          window.location.reload();
        });
      })
      .catch(() => {
        Swal.fire({
          icon: 'error',
          text: `Something Wrong during the import.`,
        });
      });
  };

  const submitImage = () => {
    Swal.fire({
      title: `Please Wait for response`,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    request({
      method: 'post',
      url: `/products/importProductsImage`,
      data: {
        prod: image,
        referTo: id,
      },
    })
      .then((res) => {
        Swal.fire({
          icon: 'success',
          text: `Your products have been imported successfully.`,
        }).then(() => {
          window.location.reload();
        });
      })
      .catch((err) => {
        Swal.fire({
          icon: 'error',
          text: err.response?.data?.error,
        });
      });
  };

  const importCode = (evt) => {
    if (!evt.target.files) {
      return;
    }
    const file = evt.target.files[0];
    try {
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: async (results) => {
          const data = results.data;
          let go = true;

          console.log('data', data);

          data.forEach((e) => {
            if (e.name === '' || e.sku === '') {
              go = false;
              return Swal.fire({
                text: `Name and SKU should not be none`,
                icon: 'error',
              });
            }
            console.log('e.name?.length', e.name?.length);
            if (e.name?.length > 33) {
              go = false;
              return Swal.fire({
                text: `Characters of name should be less than 34 characters`,
                icon: 'error',
              });
            }
            if (e.category?.length > 30 || e.brand?.length > 30) {
              go = false;
              return Swal.fire({
                text: 'Characters of category/brand should be less than 31 characters',
                icon: 'error',
              });
            }
            e.dimension = {
              length: parseFloat(e.width),
              width: parseFloat(e.depth),
              height: parseFloat(e.height),
            };
            e.price = parseFloat(e.price);
            e.costPrice = parseFloat(e.costPrice);
            if (e.brand === '') e.brand = null;
            console.log('e.dimension', e.dimension);
            if (
              isNaN(e.dimension.length) ||
              isNaN(e.dimension.width) ||
              isNaN(e.dimension.height) ||
              isNaN(e.price) ||
              isNaN(e.costPrice)
            ) {
              go = false;
              return Swal.fire({
                text: `price/costPrice/length/width/height is not a number`,
                icon: 'error',
              });
            }
            e.name = { en: e.name };
            e.description = { en: e.description };
            e.ingredients = { en: e.extraInfo1 };
            e.allergens = { en: e.extraInfo2 };
            e.title1 = { en: e.title1 };
            e.title2 = { en: e.title2 };
            const cate = e.category === '' ? [] : e.category.split(';');
            cate.forEach((ca) => {
              ca = ca.trim();
            });
            e.externalCode = e.externalCode ? e.externalCode.trim() : null;
            console.log(cate);
            e.category = cate;
          });
          console.log(data);
          evt.target.value = null;
          if (go) {
            setFileName(file.name);
            setProd(data);
            Swal.fire({
              text: `Ready for submit`,
              icon: 'success',
            });
          }
        },
      });
    } catch (err) {
      evt.target.value = null;
      console.log(err);
      return Swal.fire({
        text: `Something wrong`,
        icon: 'error',
      });
    }
  };

  const importImage = (evt) => {
    if (!evt.target.files) {
      return;
    }
    const file = evt.target.files[0];
    try {
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: async (results) => {
          const data = results.data;
          let go = true;

          const checkExtensionImage = (e) => {
            return (
              e !== 'jpg' &&
              e !== 'jpeg' &&
              e !== 'png' &&
              e !== 'JPG' &&
              e !== 'JEPG' &&
              e !== 'PNG'
            );
          };
          console.log('data', data);
          data.forEach((e) => {
            console.log('e.Image1', e.Image1);
            if (!e.UPC && !e.externalCode) {
              go = false;
              return Swal.fire({
                text: `UPC/external code should not be none`,
                icon: 'error',
              });
            }
            if (!e.Image1 || e.Image1 === '') {
              go = false;
              return Swal.fire({
                text: `Image1 should not be none`,
                icon: 'error',
              });
            }
            if (e.Image1) {
              const extention1 = e.Image1.split('.').pop();
              if (checkExtensionImage(extention1)) {
                go = false;
                return Swal.fire({
                  text: `Image1 extension is not correct`,
                  icon: 'error',
                });
              }
            }

            if (e.Image2) {
              const extention1 = e.Image2.split('.').pop();
              if (checkExtensionImage(extention1)) {
                go = false;
                return Swal.fire({
                  text: `Image2 extension is not correct`,
                  icon: 'error',
                });
              }
            }

            if (e.Image3) {
              const extention1 = e.Image3.split('.').pop();
              if (checkExtensionImage(extention1)) {
                go = false;
                return Swal.fire({
                  text: `Image3 extension is not correct`,
                  icon: 'error',
                });
              }
            }

            if (e.Video) {
              const extention1 = e.Video.split('.').pop();
              if (extention1 !== 'mp4' && extention1 !== 'MP4') {
                go = false;
                return Swal.fire({
                  text: `Video extension is not correct`,
                  icon: 'error',
                });
              }
            }
          });

          if (go) {
            setFileName(file.name);
            setImage(data);
            Swal.fire({
              text: `Ready for submit`,
              icon: 'success',
            });
          }
        },
      });
    } catch (err) {
      evt.target.value = null;
      console.log(err);
      return Swal.fire({
        text: `Something wrong`,
        icon: 'error',
      });
    }
  };

  const importJson = (evt) => {
    if (!evt.target.files || !evt.target.files[0]) {
      return;
    }
    const file = evt.target.files[0];
    const reader = new FileReader();
    reader.onload = (e) => {
      let raw;
      try {
        raw = JSON.parse(e.target.result);
      } catch (err) {
        evt.target.value = null;
        return Swal.fire({ text: `Invalid JSON file`, icon: 'error' });
      }

      const list = Array.isArray(raw) ? raw : raw.Products || raw.products || [];
      if (!Array.isArray(list) || list.length === 0) {
        evt.target.value = null;
        return Swal.fire({ text: `No products found in this JSON file`, icon: 'error' });
      }

      const products = [];
      const images = [];
      let skipped = 0;

      list.forEach((p) => {
        const upc = p.upc?.toString().trim();
        const name = p.name1?.toString().trim();
        const price = Number(p.price);
        if (!upc || !name || isNaN(price)) {
          skipped++;
          return;
        }
        products.push({
          upc,
          name: { en: name },
          detail: { en: p.detail1 ? p.detail1.toString().trim() : '' },
          description: { en: p.description1 ? p.description1.toString().trim() : '' },
          price,
          costPrice: price,
          category: p.category1 ? [p.category1.toString().trim()] : [],
        });
        if (p.pic1) {
          images.push({ UPC: upc, Image1: p.pic1 });
        }
      });

      evt.target.value = null;

      if (products.length === 0) {
        return Swal.fire({ text: `No valid products (upc/name1/price required)`, icon: 'error' });
      }

      setJsonFileName(file.name);
      setJsonProducts(products);
      setJsonImages(images);

      Swal.fire({
        text: `Ready to import ${products.length} product(s)${
          skipped > 0 ? ` (${skipped} skipped due to missing upc/name1/price)` : ''
        }`,
        icon: 'success',
      });
    };
    reader.onerror = () => {
      evt.target.value = null;
      Swal.fire({ text: `Something wrong reading the file`, icon: 'error' });
    };
    reader.readAsText(file);
  };

  const submitJson = () => {
    Swal.fire({
      title: `Please Wait for response`,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    request({
      method: 'post',
      url: `/products/importProducts`,
      data: {
        prod: jsonProducts,
        referTo: id,
      },
    })
      .then(() => {
        if (jsonImages.length === 0) {
          return Swal.fire({
            icon: 'success',
            text: `Your products have been imported successfully.`,
          }).then(() => {
            window.location.reload();
          });
        }
        return request({
          method: 'post',
          url: `/products/importProductsImage`,
          data: {
            prod: jsonImages,
            referTo: id,
          },
        }).then(() => {
          Swal.fire({
            icon: 'success',
            text: `Your products and images have been imported successfully.`,
          }).then(() => {
            window.location.reload();
          });
        });
      })
      .catch((err) => {
        Swal.fire({
          icon: 'error',
          text: err.response?.data?.error || `Something Wrong during the import.`,
        });
      });
  };

  return (
    <Modal show={show} onHide={onHide} centered size="md">
      <Modal.Header closeButton>
        <Modal.Title>Import Products</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          {/* Products Import Section */}
          <Paper
            elevation={0}
            sx={{
              p: 2.5,
              borderRadius: 2,
              border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
              backgroundColor: alpha(theme.palette.primary.main, 0.04),
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
              <DescriptionIcon sx={{ color: theme.palette.primary.main, fontSize: 20 }} />
              <Typography variant="subtitle1" sx={{ fontWeight: 600, color: theme.palette.primary.dark }}>
                Import Products by CSV
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              <Button
                variant="outlined"
                size="small"
                startIcon={<DownloadIcon />}
                onClick={downloadTemplate}
                sx={{
                  borderRadius: 2,
                  textTransform: 'none',
                  fontWeight: 600,
                  justifyContent: 'flex-start',
                }}
              >
                Download Template
              </Button>
              <Button
                component="label"
                variant="contained"
                size="small"
                startIcon={<CloudUploadIcon />}
                sx={{
                  borderRadius: 2,
                  textTransform: 'none',
                  fontWeight: 600,
                  background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
                }}
              >
                <input
                  type="file"
                  accept=".csv"
                  hidden
                  onChange={(e) => {
                    importCode(e);
                  }}
                />
                Import Products CSV
              </Button>
            </Box>
          </Paper>

          {/* JSON Import Section */}
          <Paper
            elevation={0}
            sx={{
              p: 2.5,
              borderRadius: 2,
              border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
              backgroundColor: alpha(theme.palette.info.main, 0.04),
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
              <DataObjectIcon sx={{ color: theme.palette.info.main, fontSize: 20 }} />
              <Typography variant="subtitle1" sx={{ fontWeight: 600, color: theme.palette.info.dark }}>
                Import Products by JSON
              </Typography>
            </Box>
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1.5 }}>
              Uses fields: upc, name1, detail1, description1, price, category1, pic1. Images (pic1) are
              downloaded automatically and matched by upc.
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              <Button
                component="label"
                variant="contained"
                size="small"
                color="info"
                startIcon={<CloudUploadIcon />}
                sx={{
                  borderRadius: 2,
                  textTransform: 'none',
                  fontWeight: 600,
                }}
              >
                <input
                  type="file"
                  accept=".json,application/json"
                  hidden
                  onChange={(e) => {
                    importJson(e);
                  }}
                />
                Import Products JSON
              </Button>
            </Box>
          </Paper>

          {/* Image Import Section */}
          <Paper
            elevation={0}
            sx={{
              p: 2.5,
              borderRadius: 2,
              border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
              backgroundColor: alpha(theme.palette.secondary.main, 0.04),
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
              <ImageIcon sx={{ color: theme.palette.secondary.main, fontSize: 20 }} />
              <Typography variant="subtitle1" sx={{ fontWeight: 600, color: theme.palette.secondary.dark }}>
                Import Product Images
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              <Button
                variant="outlined"
                size="small"
                startIcon={<DownloadIcon />}
                onClick={downloadTemplateImage}
                sx={{
                  borderRadius: 2,
                  textTransform: 'none',
                  fontWeight: 600,
                  justifyContent: 'flex-start',
                }}
              >
                Template (External Code)
              </Button>
              <Button
                variant="outlined"
                size="small"
                startIcon={<DownloadIcon />}
                onClick={downloadTemplateImageUPC}
                sx={{
                  borderRadius: 2,
                  textTransform: 'none',
                  fontWeight: 600,
                  justifyContent: 'flex-start',
                }}
              >
                Template (UPC)
              </Button>
              <Button
                component="label"
                variant="contained"
                size="small"
                startIcon={<CloudUploadIcon />}
                color="secondary"
                sx={{
                  borderRadius: 2,
                  textTransform: 'none',
                  fontWeight: 600,
                }}
              >
                <input
                  type="file"
                  accept=".csv"
                  hidden
                  onChange={(e) => {
                    importImage(e);
                  }}
                />
                Import Images CSV
              </Button>
            </Box>
          </Paper>

          {/* File Status */}
          {fileName !== '' && (
            <Paper
              elevation={0}
              sx={{
                p: 2,
                borderRadius: 2,
                border: `1px solid ${alpha(theme.palette.success.main, 0.3)}`,
                backgroundColor: alpha(theme.palette.success.main, 0.08),
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
              }}
            >
              <CheckCircleIcon sx={{ color: theme.palette.success.main }} />
              <Box>
                <Typography variant="body2" sx={{ fontWeight: 600, color: theme.palette.success.dark }}>
                  File Ready
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {fileName}
                </Typography>
              </Box>
            </Paper>
          )}

          {jsonFileName !== '' && (
            <Paper
              elevation={0}
              sx={{
                p: 2,
                borderRadius: 2,
                border: `1px solid ${alpha(theme.palette.success.main, 0.3)}`,
                backgroundColor: alpha(theme.palette.success.main, 0.08),
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
              }}
            >
              <CheckCircleIcon sx={{ color: theme.palette.success.main }} />
              <Box>
                <Typography variant="body2" sx={{ fontWeight: 600, color: theme.palette.success.dark }}>
                  File Ready
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {jsonFileName} — {jsonProducts.length} product(s), {jsonImages.length} image(s)
                </Typography>
              </Box>
            </Paper>
          )}
        </Box>
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={onHide}
          variant="outlined"
          sx={{
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 600,
            px: 3,
          }}
        >
          Cancel
        </Button>
        {prod.length > 0 && (
          <Button
            onClick={submit}
            variant="contained"
            sx={{
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 600,
              px: 3,
              background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
              boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.4)}`,
            }}
          >
            Submit Products
          </Button>
        )}
        {image.length > 0 && (
          <Button
            onClick={submitImage}
            variant="contained"
            color="secondary"
            sx={{
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 600,
              px: 3,
              boxShadow: `0 4px 12px ${alpha(theme.palette.secondary.main, 0.4)}`,
            }}
          >
            Submit Images
          </Button>
        )}
        {jsonProducts.length > 0 && (
          <Button
            onClick={submitJson}
            variant="contained"
            color="info"
            sx={{
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 600,
              px: 3,
              boxShadow: `0 4px 12px ${alpha(theme.palette.info.main, 0.4)}`,
            }}
          >
            Submit JSON Products
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
}
